<template>
  <ul
    class="row-1 page-product-family-products"
    v-anim-parallax-element="{
      target: 'picture',
      offset: 10,
    }"
  >
    <li
      v-for="(product, index) in formattedProducts"
      :key="product.id"
      v-anim-scroll-speed="{
        factor: index % 2 !== 0 ? 0.25 : 0,
      }"
    >
      <div class="page-product-family-products__product">
        <WidgetContentBlock :content="product" />
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'PagesProductFamilyProducts',
}
</script>

<script setup>
const props = defineProps({
  family: Object,
})

const formattedProducts = computed(() => {
  return props.family.children.map((product) => ({
    title: product.title,
    cover: product.coverPortrait?.[0] || product.cover?.[0],
    route: {
      name: 'product-slug',
      params: { slug: product.slug },
    },
  }))
})
</script>

<style lang="scss">
@import './style.scss';
</style>
